/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import GridContainer from 'components/Grid/GridContainer.jsx';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { ComponentByGroup } from './component/ComponentByGroup';

class FeaturesNotActiveList extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            simCard: this.props.simCard,
            groupList: null,
            expanded: false,
            alert: null,
            activateParams: null,
        };
        this.loader = new ItemLoaders(this.props.dispatch);
    }

    componentDidMount() {
        this.initial();
    }

    initial = () => {
        const { simCard } = this.props;
        this.loader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_groups')),
            'none',
            [
                { name: 'visible', value: 'true' },
                { name: 'operatorType[]', value: '-1' },
                { name: 'operatorType[]', value: simCard.operatorType },
            ],
            [{ name: 'groupPriority', value: 'asc' }],
            (data) => {
                this.setState({
                    groupList: data,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    handleChange = (panelName) => (event, isExpanded) => {
        this.setState({ expanded: isExpanded ? panelName : false });
    };

    render() {
        const { simCard, groupList, alert } = this.state;
        return (
            <GridContainer>
                {groupList &&
                    groupList['hydra:member'] &&
                    groupList['hydra:member'].map((row) => {
                        return (
                            <ComponentByGroup
                                key={'group' + row.id}
                                groupId={row.id}
                                simCardId={simCard.id}
                                simCard={simCard}
                                groupName={row.mainname}
                            />
                        );
                    })}
                {alert}
            </GridContainer>
        );
    }
}

FeaturesNotActiveList.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return {
        ...state,
    };
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(FeaturesNotActiveList);
export default Enhance;
